import { lazy } from 'react';
import AccessPolicy from '../../enums/accessPolicy';
import Route from '../../enums/route';
const HomePage = lazy(() => import('../../components/pages/Home'));
const AdminsPage = lazy(() => import('../../components/pages/admins'));
const ProfilePage = lazy(() => import('../../components/pages/Profile'));
const ClientsPage = lazy(() => import('../../components/pages/clients'));
const CompaniesPage = lazy(() => import('../../components/pages/companies'));
const UsersPage = lazy(() => import('../../components/pages/users'));
const CalculationsPage = lazy(() => import('../../components/pages/calculations'));
const DisplayCalculationPage = lazy(() => import('../../components/pages/calculation/displayCalculation'));
const DocumentsPage = lazy(() => import('../../components/pages/documents'));
const CreateHistoricalModulePage = lazy(() => import('../../components/pages/historicalModule/createHistoricalModule'));
const EditHistoricalModulePage = lazy(() => import('../../components/pages/historicalModule/editHistoricalModule'));
const DisplayHistoricalModulePage = lazy(() => import('../../components/pages/historicalModule/displayHistoricalModule'));
const EditCalculationPage = lazy(() => import('../../components/pages/calculation/editCalculation'));
export const authenticatedRoutes = [
    {
        path: Route.Admins,
        component: AdminsPage,
        policy: {
            id: AccessPolicy.ViewKpmgAdmins
        }
    },
    {
        path: Route.Clients,
        component: ClientsPage,
        policy: {
            id: AccessPolicy.ViewClientAdmins
        }
    },
    {
        path: Route.Companies,
        component: CompaniesPage,
        policy: {
            id: AccessPolicy.ViewCompanies
        }
    },
    {
        path: Route.Users,
        component: UsersPage,
        policy: {
            id: AccessPolicy.ViewUsers
        }
    },
    {
        path: Route.Profile,
        component: ProfilePage
    },
    {
        path: Route.Home,
        component: HomePage
    },
    {
        path: Route.Calculations,
        component: CalculationsPage,
        policy: {
            id: AccessPolicy.ViewCalculations
        }
    },
    {
        path: Route.EditCalculation,
        component: EditCalculationPage,
        policy: {
            id: AccessPolicy.EditCalculation
        }
    },
    {
        path: Route.DisplayCalculation,
        component: DisplayCalculationPage,
        policy: {
            id: AccessPolicy.ViewCalculation
        }
    },
    {
        path: Route.Documents,
        component: DocumentsPage,
        policy: {
            id: AccessPolicy.ViewDocuments
        }
    },
    {
        path: Route.CreateHistoricalModule,
        component: CreateHistoricalModulePage
    },
    {
        path: Route.EditHistoricalModule,
        component: EditHistoricalModulePage
    },
    {
        path: Route.DisplayHistoricalModule,
        component: DisplayHistoricalModulePage
    }
];
